import {
  FormSubmitArgs,
  FormViewConfig,
  FormViewService,
  vsServiceName as FormViewServiceName,
  FormViewServiceProvider,
  vsProviderName as FormViewServiceProviderName,
} from "../../records/forms/formView";
import { RecordDataSource } from "../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../records/grids/columns/columnDefinitionService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../records/views/recordGridView";
import fieldHelpers from "../../ui-formly/fieldHelpers";
import {
  LookupManagementConfig,
  LookupManagementServiceProvider,
} from "../../records/lookup/lookupManagement";
import { vsLookupManagementServiceProviderName } from "./lookupManagement";

export const vsObjectName = "performanceGuaranteeType";

const url = "api/contract/performanceGuaranteeType";

PerformanceGuaranteeConfig.$inject = [
  FormViewServiceProviderName,
  RecordGridViewServiceProviderName,
  vsLookupManagementServiceProviderName,
];

export function PerformanceGuaranteeConfig(
  formViewServiceProvider: FormViewServiceProvider,
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  lookupManagementServiceProvider: LookupManagementServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(
    vsObjectName,
    getGridConfig
  );
  lookupManagementServiceProvider.addLookup(vsObjectName, {
    displayName: "Performance Guarantee",
    config: [
      ServerUtilityName,
      (serverUtility: ServerUtility) => {
        const config: LookupManagementConfig = {
          fetchFormModel(id) {
            return serverUtility.querySingle({
              url,
              query: { Id: id },
            });
          },
          baseUrl: url,
        };
        return config;
      },
    ],
  });
  formViewServiceProvider.addFormViewConfig(vsObjectName, getFormConfig);
}

getGridConfig.$inject = [ServerUtilityName, ColumnDefinitionServiceName];
function getGridConfig(
  serverUtility: ServerUtility,
  columnDefinitionService: ColumnDefinitionService
): GridConfiguration {
  return {
    columns: [
      columnDefinitionService.getNumberColDef({ field: "Id", hide: true }),
      columnDefinitionService.getStringColDef({
        field: "Name",
        header: "Performance Guarantee",
      }),
      columnDefinitionService.getBooleanColDef({
        field: "Disabled",
      }),
    ],
    gridDataSource: new RecordDataSource(serverUtility, url),
    defaultSort: "Name",
    namePlural: "Performance Guarantee",
    nameSingular: "Performance Guarantee",
    showAddButton: true,
    showAddButtonPermission: "contractLookupModify",
    showSelectButtons: false,
  };
}

getFormConfig.$inject = [FormViewServiceName];
function getFormConfig(formViewService: FormViewService): FormViewConfig {
  return {
    fields: [
      fieldHelpers.simpleStringField({
        key: "Name",
        label: "Performance Guarantee",
        required: true,
      }),
      fieldHelpers.simpleBoolField({
        key: "Disabled",
        defaultValue: false,
      }),
    ],
    title: (model) =>
      model.Id ? "Edit Performance Guarantee" : "Create Performance Guarantee",
    name: vsObjectName,
    submitForm: (args: FormSubmitArgs) => {
      const model = args.model;
      return formViewService.saveForm({
        formObject: model,
        formViewController: args.formViewController,
        url,
      });
    },
  };
}
